import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import { Icon } from "../../icons";
import { COLORS, TYPOGRAPHY } from "../../constants/color";


const calculateRemainingCredits = (client) => {
 
  const used = client?.credits?.usedCredits || 0;
  const remaining = client?.credits?.totalCredits || 0;
   const total = used+remaining;
  // Check if client has no credits at all
  const hasCredits = client?.credits && (total > 0 || used > 0);
  
  if (!hasCredits) {
    return {
      remaining: 0,
      total: 0,
      used: 0,
      display: "-"
    };
  }
  
  return {
    remaining: remaining,
    total: total,
    used: used,
    display: `${remaining}/${total}`
  };
};

const ClientDeleteModal = ({
  open,
  onClose,
  client,
  onConfirmDelete,
}) => {
  if (!open || !client) return null;
  
  // Calculate credits info
  const creditsInfo = calculateRemainingCredits(client);
  
  return (
    <>
      {/* Overlay */}
      <Box
        onClick={onClose}
        sx={{
          position: "fixed",
          inset: 0,
          bgcolor: "rgba(0,0,0,0.5)",
          zIndex: 1400,
        }}
      />

      {/* Modal */}
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 560,
          bgcolor: "#fff",
          borderRadius: 2,
          p: 3,
          zIndex: 1401,
          border: `2px solid ${COLORS.ERROR}`, // 🔴 RED BORDER
          boxShadow: "0px 12px 30px rgba(0,0,0,0.2)",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Typography sx={{ ...TYPOGRAPHY.H3, color: COLORS.ERROR }}>
            Remove Client from View
          </Typography>

          <IconButton onClick={onClose} sx={{ p: 1 }}>
            <Icon name="close" color={COLORS.ERROR} />
          </IconButton>
        </Box>

     <Box sx={{ mb: 2 }}>
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
    }}
  >
    {/* LEFT COLUMN */}
    <Box>
      {/* Name + Status */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Icon name="profile" color={COLORS.PRIMARY} />
        <Typography sx={{...TYPOGRAPHY.H3 ,color: COLORS.TEXT}}>
          {client.name}
        </Typography>
      </Box>

      {/* Email */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1, pl:"24px" }}>
        <Icon name="at" size={14} color={COLORS.SECONDARY} />
        <Typography sx={{...TYPOGRAPHY.BODY_STANDARD, color: COLORS.SECONDARY}}>
          {client.email}
        </Typography>
      </Box>

      {/* Phone */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5, pl:"24px" }}>
        <Icon name="phoneDone" size={14} color={COLORS.SECONDARY} />
          <Typography sx={{...TYPOGRAPHY.BODY_STANDARD, color: COLORS.SECONDARY}}>
          {client.phone}
        </Typography>
      </Box>
    </Box>

    {/* RIGHT COLUMN (ROW ALIGNED) */}
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
      }}
    >
      {/* Row 1 — aligns with Name */}
      <Typography sx={{...TYPOGRAPHY.BODY_LARGE, color: COLORS.TEXT}}>
        Joined on:{" "}
        {new Date(
          client.joinedAt || client.createdAt
        ).toLocaleDateString("en-GB", {
  day: "2-digit",
  month: "2-digit",
  year: "2-digit",
}).replace(/\//g, '/')}
      </Typography>

      {/* Row 2 — spacer for Email */}
      <Box sx={{ height: 30 }} />

      {/* Row 3 — aligns with Phone */}
      <Typography
        sx={{
          ...TYPOGRAPHY.BODY_SMALL,
          color: COLORS.SECONDARY,
          whiteSpace: "nowrap",
        }}
      >
        Credits: {creditsInfo.display}
      </Typography>
    </Box>
  </Box>
</Box>

        <Box sx={{ borderTop: `1px solid ${COLORS.LIGHT_SECONDARY}`, my: 2 }} />

        {/* Warning Text */}
        <Typography sx={{ ...TYPOGRAPHY.BODY_LARGE, color: COLORS.TEXT, mb: 3 }}>
          This will permanently remove "{client.name}" from your client list.
          <br />
         
        </Typography>

        {/* Actions */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ textTransform: "none" }}
            startIcon={<Icon name="close2" />}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            startIcon={<Icon name="check" />}
            sx={{ textTransform: "none" }}
            onClick={() => onConfirmDelete(client)}
          >
            Delete
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ClientDeleteModal;